import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-32 bg-white overflow-hidden relative" data-id="element-499">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-500">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-cream rounded-[3rem] p-10 sm:p-20 shadow-premium border border-ink/5 relative overflow-hidden" data-id="element-501">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-combo-green/10 via-transparent to-transparent opacity-50" data-id="element-502"></div>

          <div className="relative z-10 max-w-3xl mx-auto" data-id="element-503">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-ink mb-6 tracking-tight" data-id="element-504">
              Empezá hoy mismo a transformar tu alimentación.
            </h2>

            <p className="text-lg sm:text-xl text-ink-light mb-12 font-light leading-relaxed" data-id="element-505">
              No esperes más para sentirte mejor. Accedé a todo el material
              ahora y da el primer paso hacia tu mejor versión.
            </p>

            <a href="#kits" className="inline-flex w-full sm:w-auto items-center justify-center bg-combo-green text-white px-12 py-6 rounded-full font-bold text-xl hover:bg-combo-green/90 transition-all shadow-premium hover:shadow-premium-hover hover:-translate-y-1" data-id="element-506">
              QUIERO ACCEDER AHORA
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}